import React from "react";
import { useSelector } from "react-redux";

export default function WelcomeHomeForSwissUser() {
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const displayName =
    onboardingData?.name || user?.profile?.bia?.full_name || "user";

  return (
    <div className="bg-white rounded-xl px-6 py-8 border border-brand-textLightGrey/40">
      <div className="w-full h-[450px] flex items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <div className="text-sm tracking-wide text-brand-textLightGrey uppercase">
            Welcome
          </div>
          <div className="text-3xl font-extrabold text-brand-orange capitalize">
            {displayName}
          </div>
        </div>
      </div>
    </div>
  );
}
